import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

import {findValueOf, isDefined } from "@wm/core";
import {debounce, isArray,isString} from "lodash-es";
import {getDecimalCount, isPercentageValue} from "./utils";


const DEFAULT_CLS = 'progress app-progress';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-progress-bar',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

export const TYPE_CLASS_MAP:any = {
  'default': '',
  'default-striped': 'progress-bar-striped',
  'success': 'progress-bar-success',
  'success-striped': 'progress-bar-success progress-bar-striped',
  'info': 'progress-bar-info',
  'info-striped': 'progress-bar-info progress-bar-striped',
  'warning': 'progress-bar-warning',
  'warning-striped': 'progress-bar-warning progress-bar-striped',
  'danger': 'progress-bar-danger',
  'danger-striped': 'progress-bar-danger progress-bar-striped'
};
interface IProgressInfo {
  cls: string;
  progressBarWidth: string;
  displayValue: string;
}
@Component({
  selector: '[wmProgressBar]',
  template: `<div class="multi-bar progress-bar {{bar.cls}}" *ngFor="let bar of data" [style.width]="bar.progressBarWidth" role="progressbar"
                  [attr.aria-valuenow]="datavalue" [attr.aria-valuemin]="minvalue" [attr.aria-valuemax]="maxvalue" [attr.aria-label]="hint || 'Progress bar'">
    <span class="app-progress-label" [attr.data-caption-placement]="captionplacement">{{bar.displayValue}}</span>
  </div>
  `,
  providers: [
    provideAsWidgetRef(ProgressBarComponent)
  ],
  exportAs: 'wmProgressBar',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class ProgressBarComponent extends StylableComponent {
  static initializeProps = register('wm-progress-bar');
  public displayformat: string;
  public datavalue: string;
  public minvalue: number;
  public maxvalue: number;
  public type: string;
  public dataset: Array<any>;
  public hint: string;

  private _prepareData: Function;
  private readonly hasDataset: boolean;
  captionplacement: any;

  // progress-bar data, ngFor in the template iterates on this
  public data: Array<IProgressInfo> = [{
    cls: TYPE_CLASS_MAP.default,
    progressBarWidth: '0%',
    displayValue: '0'
  }];

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    this._prepareData = debounce(() => this.prepareData(), 50);
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'type') {
      this.onTypeChange();
    } else if (key === 'minvalue' || key === 'maxvalue' || key === 'datavalue' || key === 'dataset' || key === 'displayformat') {
      this._prepareData();
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  protected onTypeChange() {
    if (!this.hasDataset) {
      if (this.data[0]) {
        this.data[0].cls = TYPE_CLASS_MAP[this.type];
      }
    }
  }

  protected prepareData() {
    // when the dataset is provided, iterate over the dataset to set the proper values in the data
    if (this.dataset && isArray(this.dataset) && this.type && this.datavalue) {
      this.data = this.dataset.map((datum): IProgressInfo => {
        const val: string = findValueOf(datum, this.datavalue).toString();
        let percentVal = val;
        if (val && !val.includes('%')) {
          percentVal = `${val}%`;
        }
        return {
          cls: TYPE_CLASS_MAP[findValueOf(datum, this.type)],
          progressBarWidth: percentVal,
          displayValue: this.getFormattedDisplayVal(val)
        };
      });
    } else {
      // if the dataset is not provided, update the values in the default data
      let width: string | number = 0;
      let displayVal: string | number = 0;
      if (this.datavalue) {
        if (isPercentageValue(this.datavalue)) {
          const val = (this.datavalue || '0%');
          width = displayVal = val;
        } else {
          if (isDefined(this.datavalue)) {
            const denominator = (+this.maxvalue - +this.minvalue) || 1;
            const val = ((+this.datavalue - +this.minvalue) * 100) / denominator + '%';
            width = displayVal = val;
          }
        }
      }
      this.data[0].displayValue = this.getFormattedDisplayVal(displayVal as string);
      this.data[0].progressBarWidth = width as string;
      this.data[0].cls = TYPE_CLASS_MAP[this.type];

    }
  }

  protected getFormattedDisplayVal(val: string | number): any {
    const format = this.displayformat || '9';

    val = parseFloat('' + val);
    val = (val.toFixed(getDecimalCount(format)));

    if (format && format.includes('%')) {
      val = `${val}%`;
    }
    return val;
  }

}



